import React from 'react';
import styled from 'styled-components';
import { Container, Typography, Link, IconButton } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { SiTiktok, SiYoutube } from 'react-icons/si';
import { FaFacebook } from 'react-icons/fa';

const FooterWrapper = styled.footer`
  background: var(--primary-color);
  color: white;
  padding: 40px 0 ;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 40px;
  
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const Logo = styled.img`
  height: 104px;
  object-fit: contain;
  filter: drop-shadow(0 2px 8px rgba(227,24,55,0.12));
  border-radius: 14px;
  background: #fff;
  padding: 6px 18px;
  transition: box-shadow 0.3s, background 0.3s;
  border: 1.5px solid #e31837;
  &:hover {
    box-shadow: 0 8px 32px rgba(227,24,55,0.18);
    background: #f5f5f5;
  }
`;

const CompanyInfo = styled.div`
  margin-bottom: 20px;
`;

const Title = styled(Typography)`
  color: white;
  font-size: 20px !important;
  font-weight: bold !important;
  margin-bottom: 20px !important;
  position: relative;
  padding-bottom: 10px;
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 230px;
    height: 3px;
    background: #e31837;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  
  .MuiSvgIcon-root {
    color: #000;
    margin-right: 10px;
    margin-top: 4px;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px dashed #fff;
  font-size: 14px;
  color: #fff;
`;

const SocialMediaSection = styled.div`
  margin-bottom: 30px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
  
  .MuiIconButton-root {
    color: #fff;
    border: 2px solid #fff;
    padding: 8px;
    background-color: #000;
    
    svg {
      font-size: 24px;
    }
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterGrid>
          <div>
            <Logo src="https://res.cloudinary.com/drbjrsm0s/image/upload/v1748576489/logo_pwjled.png" alt="Ô Tô Gia Phát" />
            <CompanyInfo>
              <Typography variant="h6">Gia Phát Auto - Dịch Vụ Hoàn Hảo - Tận Tâm và Chuyên Nghiệp - Sửa Xe Bằng Cả Trái Tim</Typography>
              <Typography>CÔNG TY TNHH THƯƠNG MẠI DỊCH VỤ GIA PHÁT AUTO</Typography>
              <Typography>Mã số thuế / Mã số doanh nghiệp : 0316563009</Typography>
              <Typography>Hỗ trợ khách hàng</Typography>
              <Typography>0913.169.066</Typography>
            </CompanyInfo>
          </div>

          <div>
            <SocialMediaSection>
              <Title variant="h6">THEO DÕI CHÚNG TÔI</Title>
              <SocialIcons>
                <IconButton href="https://www.facebook.com/profile.php?id=61576099125776" target="_blank" aria-label="Facebook">
                  <FaFacebook />
                </IconButton>
                <IconButton href="https://www.tiktok.com/@congtytnhhbathanh" target="_blank" aria-label="TikTok">
                  <SiTiktok />
                </IconButton>
                <IconButton href="https://www.youtube.com/@congtytnhhbathanhq12" target="_blank" aria-label="YouTube">
                  <SiYoutube />
                </IconButton>
              </SocialIcons>
            </SocialMediaSection>
          </div>

          <div>
            <Title variant="h6">THÔNG TIN LIÊN HỆ</Title>
            <ContactItem>
              <LocationOnIcon />
              <Typography>
                ĐỊA CHỈ<br />
                Số 06, Đường DN6, KDC AN SƯƠNG, P. TÂN HƯNG THUẬN, Q. 12
              </Typography>
            </ContactItem>
            <ContactItem>
              <PhoneIcon />
              <div>
                <Typography>HOTLINE<br />0913.169.066</Typography>
              </div>
            </ContactItem>
            <ContactItem>
              <EmailIcon />
              <div>
                <Typography>EMAIL</Typography>
                <Link href="mailto:ctygiaphatauto@gmail.com" color="inherit">ctygiaphatauto@gmail.com</Link><br />
              </div>
            </ContactItem>
          </div>
        </FooterGrid>

        <Copyright>
          ® Ghi rõ nguồn "giaphatauto.com" khi trích dẫn thông tin từ website này.
        </Copyright>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;